module.exports = __webpack_public_path__ + "img/projects-shape-3.ce149269.png";